// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

import NoFollowLink from './NoFollowLink';
import ActionLogo from './svg/ActionLogo';
import CopyIcon from './svg/CopyIcon';
import { FormattedPromotion } from '../../types';

interface PromotionCardProps {
    promotion: FormattedPromotion | null;
    logPromotionClick: () => void;
    handleBonusCodeClick?: () => void;
    handleBonusCopyClick?: () => void;
    bonusCodeWasClicked?: boolean;
    useBoxShadow?: boolean;
    promoValidDate?: string;
    terms?: 'geo' | 'affiliate';
    reveal?: string;
    revealText?: string;
    bonusOpen?: boolean;
    newTab?: boolean;
}

const BonusPromotionCardSmall: FunctionalComponent<PromotionCardProps> = ({
    promotion,
    logPromotionClick,
    useBoxShadow = false,
    reveal = 'false',
    revealText = 'Reveal Code',
    promoValidDate,
    handleBonusCodeClick,
    handleBonusCopyClick,
    bonusCodeWasClicked = false,
    bonusOpen = false,
    newTab = false,
}) => {
    if (reveal === 'animated' && revealText === 'Reveal Code') {
        revealText = 'Reveal Bonus Code'; // Default value for revealText is different on animated
    }

    const copyClick = () => {
        logPromotionClick();
        handleBonusCopyClick();
    };

    const codeClick = () => {
        logPromotionClick();
        handleBonusCodeClick();
    };

    const handleClick = () => {
        logPromotionClick();
        if (newTab) {
            const selfLink = window.location.pathname + '?showBonus=true';
            window.open(selfLink, '_blank');
        }
    };

    const propMarfeelConversion = promotion?.link && promotion?.link.includes('switchboard') ? 'switchboard-click' : '';

    if (window.location.href.includes('showBonus')) {
        bonusOpen = true;
    }

    return (
        <div class="bonus-component">
            <div class="bonus-component__cta">{promotion.cta}</div>
            <div class="bonus-component__info">
                <div class="bonus-component__verified">Verified: {promoValidDate}</div>
                <ActionLogo />
            </div>
            {(reveal === 'animated' || reveal === 'true') && (
                <div>
                    <div style={{ position: 'relative', marginBottom: '0.5rem' }}>
                        {bonusOpen && (
                            <div class="bonus-component__buttons">
                                <div class="bonus-component__code-container bonus-component__code-container-orange">
                                    <button class="bonus-component__bonus" onClick={copyClick}>
                                        <div>
                                            <div class="bonus-component__bonus-label">Copy promo code</div>
                                            <div class="bonus-component__bonus-code">
                                                {promotion?.bonusCode || 'NO CODE NEEDED'}
                                            </div>
                                        </div>
                                        {bonusCodeWasClicked ? <ActionLogo /> : <CopyIcon />}
                                    </button>
                                </div>
                                <NoFollowLink
                                    class={
                                        useBoxShadow
                                            ? `item item__shadow font no-decoration`
                                            : `item font no-decoration`
                                    }
                                    onClick={logPromotionClick}
                                    href={promotion?.link}
                                >
                                    <button class="bonus-component__claim">
                                        <div class="bonus-component__bonus-label-white">Continue to</div>
                                        <div class="bonus-component__bonus-code">{promotion.bookName}</div>
                                    </button>
                                </NoFollowLink>
                            </div>
                        )}
                        {!bonusOpen && (
                            <NoFollowLink
                                class={
                                    useBoxShadow ? `item item__shadow font no-decoration` : `item font no-decoration`
                                }
                                onClick={handleClick}
                                href={promotion?.link}
                                target={newTab ? '_self' : '_blank'}
                            >
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                        type="text"
                                        value={`${promotion?.bonusCode || 'NO CODE NEEDED'}`}
                                        readonly="readonly"
                                        class="bonus-input link"
                                    />

                                    <button
                                        class="anim_counter_btn anim-btn link"
                                        onClick={codeClick}
                                        data-mrf-conversion={propMarfeelConversion}
                                    >
                                        <span class="anim_bonus-cover">{revealText}</span>
                                    </button>
                                    <div class="button__corner"></div>
                                </div>
                            </NoFollowLink>
                        )}
                    </div>
                </div>
            )}
            {reveal === 'false' && (
                <div class="bonus-component__buttons">
                    <div class="bonus-component__code-container">
                        <button class="bonus-component__bonus" onClick={copyClick}>
                            <div>
                                <div class="bonus-component__bonus-label">Copy promo code</div>
                                <div class="bonus-component__bonus-code">
                                    {promotion?.bonusCode || 'NO CODE NEEDED'}
                                </div>
                            </div>
                            {bonusCodeWasClicked ? <ActionLogo /> : <CopyIcon />}
                        </button>
                    </div>
                    <NoFollowLink
                        class={useBoxShadow ? `item item__shadow font no-decoration` : `item font no-decoration`}
                        onClick={logPromotionClick}
                        href={promotion?.link}
                    >
                        <button class="bonus-component__claim" data-mrf-conversion={propMarfeelConversion}>
                            {promotion?.buttonText || `Claim ${promotion.bookName} Promo`}
                        </button>
                    </NoFollowLink>
                </div>
            )}
        </div>
    );
};

export default BonusPromotionCardSmall;
